export const EmployeesColumns = [
    {
        name: 'Сотрудник',
        key: 'fullName',
    },
    {
        name: 'Должность',
        key: 'job',
    },
    {
        name: 'Отдел',
        key: 'department',
    },
    {
        name: 'E-mail',
        key: 'email',
    },
    {
        name: 'Телефон',
        key: 'phoneNumber',
    },
    {
        name: 'Состояние',
        key: 'status',
    },
]
